export const environment = {
  coreApiUrl: process.env.REACT_APP_CORE_API_URL!,
  analyticsApiUrl: process.env.REACT_APP_ANALYTICS_API_URL!,
  localApi: process.env.REACT_APP_LOCAL_API_URL!,
  awsRegion: process.env.REACT_APP_AWS_REGION!,
  identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID!,
  userPoolId: process.env.REACT_APP_USER_POOL_ID!,
  userPoolWebClientId: process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID!,
  stripeKey: process.env.REACT_APP_STRIPE_KEY!,
  fanboardUrl: process.env.REACT_APP_FANBOARD_URL!,
  castAppId: process.env.REACT_APP_CAST_APP_ID!,
  searchFolderLabel: 'in',
  searchKeywordLabel: 'keyword',
  searchTypeLabel: 'type',
  facebookAppId: process.env.REACT_APP_FACEBOOK_APP_ID!,
  youtubeClientId: process.env.REACT_APP_YOUTUBE_CLIENT_ID!,
  googleCaptchaSiteKey: process.env.REACT_APP_GOOGLE_CAPTCHA_SITE_KEY!,
  baseUrl: process.env.REACT_APP_BASE_URL!,
  env: process.env.REACT_APP_ENV!,
};
